export const CURRENCY_OPTIONS = [
  { value: "GBP", label: "£GBP" },
  { value: "USD", label: "$USD" },
  { value: "EUR", label: "€EUR" },
];
